<template>
  <div class="container">
    <h1>{{ $t("register2") }}</h1>

    <b-form-group
      v-slot="{ ariaDescribedby }"
      :label="$t('chooseHowYouWantToRegister')"
    >
      <b-form-radio
        v-model="registerType"
        :aria-describedby="ariaDescribedby"
        name="some-radios"
        value="company"
        >Company/Individual</b-form-radio
      >
      <b-form-radio
        v-model="registerType"
        :aria-describedby="ariaDescribedby"
        name="some-radios"
        value="dealer"
        >{{ $t("dealer2") }}</b-form-radio
      >
    </b-form-group>
    <hr class="ms-0 me-0" />

    <register-form-company v-if="registerType === 'company'" />
    <register-form-dealer v-if="registerType === 'dealer'" />
  </div>
</template>

<script>
import { BFormRadio, BFormGroup } from "bootstrap-vue"
import RegisterFormCompany from "./RegisterFormCompany.vue"
import RegisterFormDealer from "./RegisterFormDealer.vue"
export default {
  name: "ShopRegister",
  components: {
    "register-form-company": RegisterFormCompany,
    "register-form-dealer": RegisterFormDealer,
    BFormRadio,
    BFormGroup,
  },
  data: function () {
    return {
      registerType: "company",
    }
  },
}
</script>
